import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationI } from '../../../interfaces/notifications/notification.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { MessageService } from '../../../services/message.service';
import { NotificationsService } from '../../../services/notifications.service';

@Component({
  selector: 'app-user-notifications-list',
  templateUrl: './user-notifications-list.component.html',
  styleUrls: ['./user-notifications-list.component.scss']
})
export class UserNotificationsListComponent implements OnInit {

  // region Atributos
  @Input() userNotifications: NotificationI[];
  @Input() user: UserI;
  @Output() updateList = new EventEmitter();

  searchKey: string;
  listNotifications: MatTableDataSource<any>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  listOfColumns: string[] = ['mensaje', 'enviado_el', 'leido', 'activo', 'acciones'];
  public spinner = false;
  // endregion

  // region Constructor
  constructor(
    public messageService: MessageService,
    public notificationServ: NotificationsService,
    public messageServ: MessageService
  ) {

  }

  // endregion

  // region Métodos
  ngOnInit() {
    this.listNotifications = new MatTableDataSource(this.userNotifications);
    this.listNotifications.sort = this.sort;
    this.listNotifications.paginator = this.paginator;
  }

  // Función para borrar el filtro de busqueda
  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  // Función para aplicar el filtro de busqueda
  applyFilter() {
    this.listNotifications.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  deleteNotification(notification: NotificationI) {
    this.messageServ.confirmRequest('¿Estás seguro de querer borrar esta notificación?').then((data) => {
      if (data.value) {
        this.notificationServ.deleteNotification(notification.id).subscribe(res => {
          if (res.ok === true) {
            this.messageServ.printStatus('Notificación eliminada correctamente', 'success');
            this.updateList.emit(true);
          }
        }, error => {
          console.log(error);
          this.messageServ.printStatusArray(error.error.errors, 'error');
        })
      }
    });
  }

  // endregion

}
